import { render, staticRenderFns } from "./CreateFormSalon.vue?vue&type=template&id=ae577c64&scoped=true"
import script from "./CreateFormSalon.vue?vue&type=script&lang=ts"
export * from "./CreateFormSalon.vue?vue&type=script&lang=ts"
import style0 from "./CreateFormSalon.vue?vue&type=style&index=0&id=ae577c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae577c64",
  null
  
)

export default component.exports